import * as React from 'react';
import { Link } from 'react-router';
import { cn } from '@/lib/utils';
import { NavigationMenuLink } from './ui/navigation-menu';

interface ListItemProps extends React.ComponentPropsWithoutRef<'a'> {
  title?: string;
  href?: string;
  target?: string;
}

const ListItem = React.forwardRef<React.ElementRef<'a'>, ListItemProps>(
  ({ className, title, children, href, target, ...props }, ref) => {
    const isExternal = href?.startsWith('http') || target === '_blank';

    return (
      <li>
        <NavigationMenuLink asChild>
          {isExternal ? (
            <a
              ref={ref}
              href={href}
              target={target}
              rel={target === '_blank' ? 'noopener noreferrer' : undefined}
              className={cn(
                'hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground block space-y-1 rounded-md p-3 leading-none no-underline transition-colors outline-none select-none',
                className
              )}
              {...props}
            >
              <div className="text-sm leading-none font-medium">{title}</div>
              <p className="text-muted-foreground line-clamp-2 text-sm leading-snug">{children}</p>
            </a>
          ) : (
            <Link
              to={href || '#'}
              className={cn(
                'hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground block space-y-1 rounded-md p-3 leading-none no-underline transition-colors outline-none select-none',
                className
              )}
              {...(props as any)}
            >
              <div className="text-sm leading-none font-medium">{title}</div>
              <p className="text-muted-foreground line-clamp-2 text-sm leading-snug">{children}</p>
            </Link>
          )}
        </NavigationMenuLink>
      </li>
    );
  }
);
ListItem.displayName = 'ListItem';
export default ListItem;
